import React from "react";
import { T } from "Components";

import DashboardCard from "./DashboardCard";
import useStatistics from "../../Infrastructure/useStatistics";
import { FormatActivityTime, FormatNumber } from "../../Infrastructure/format";

/** İşlem türü → rozet rengi. Sunucudaki ResolveActivityKind ile aynı anahtarlar. */
const KIND_TONE = {
  payment: "teal",
  sample: "primary",
  animal: "amber",
  member: "primary",
  other: "red",
};

const RecentActivities = () => {
  const { data, loading, error } = useStatistics("/Statistics/RecentActivities", []);

  const activities = Array.isArray(data) ? data : [];

  return (
    <DashboardCard
      title={T.Main("Dashboard.Statistics.RecentActivities")}
      description={`${FormatNumber(activities.length)} ${T.Main(
        "Dashboard.Statistics.RecordCount",
      )}`}
      loading={loading}
      error={error}
      empty={activities.length === 0}
      bodyClassName="fdash__activity"
    >
      {activities.map((activity) => {
        const tone = KIND_TONE[activity.Kind] ?? "primary";

        return (
          <div className="fdash__activity__row" key={activity.Id}>
            <span
              className="fdash__activity__tag"
              style={{ background: `var(--${tone}-soft)`, color: `var(--${tone})` }}
            >
              {activity.Tag}
            </span>
            <span className="fdash__activity__text">{activity.Text}</span>
            <span className="fdash__activity__time">
              {FormatActivityTime(activity.CreatedOnUtc)}
            </span>
          </div>
        );
      })}
    </DashboardCard>
  );
};

export default RecentActivities;
